import { axiosHelper } from 'Services/AxiosHelper';
import { OnCountInstructionListModel } from 'Models';
import { onConfirmEmailReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnConfirmEmail';

const onConfirmEmail = async (params: onConfirmEmailReqBodyData): Promise<OnCountInstructionListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onConfirmEmail;
